const { getVisit } = require('../visit');
const { version } = require('../libraryInfo');
const Globals = require('../globals');

class TrackingStub {
    static METHOD_NAMES = ['page', 'track', 'trackLink', 'trackNavigation', 'identify', 'reset', 'setAnonymousId'];

    constructor() {
        this._calls = [];
        this._realTracking = null;
        this._isReady = false;
        TrackingStub.METHOD_NAMES.forEach((method) => {
            this[method] = (...args) => this._memoize(method, args);
        });

        this.waitForTrackingReady();
    }

    waitForTrackingReady() {
        const tracking = Globals.getTracking();
        if (tracking) {
            this.setRealTracking(tracking);
            return;
        }

        if (typeof window !== 'undefined') {
            const handleTrackingReady = () => {
                const realTracking = Globals.getTracking();
                if (realTracking) {
                    this.setRealTracking(realTracking);
                }
                window.removeEventListener('trackingReady', handleTrackingReady);
            };
            window.addEventListener('trackingReady', handleTrackingReady);
        }
    }

    visit() {
        return getVisit();
    }

    version() {
        return version;
    }

    isReady() {
        return this._isReady;
    }

    setRealTracking(realTracking) {
        this._realTracking = realTracking;
        this._isReady = true;
        this._calls.forEach(({ method, args }) => {
            if (typeof realTracking[method] === 'function') {
                realTracking[method](...args);
            }
        });
        this._calls = [];
    }

    _memoize(method, args) {
        if (this._isReady && this._realTracking) {
            return this._realTracking[method](...args);
        }
        this._calls.push({ method, args });
    }
}

function createTrackingStub() {
    return new TrackingStub();
}

module.exports = { createTrackingStub };
